@if(errorMessage$ | async; as errorMessage) {
  <div class="error-message-container">
    <p class="error-message" data-testid="base-global-error-message">{{errorMessage}}</p>
  </div>
}

